import { defineComponent as m, useAttrs as f, computed as o, reactive as b, provide as g, openBlock as h, createElementBlock as k, mergeProps as x, unref as r, renderSlot as y } from "vue";
import { CheckboxSizes as B, CheckboxDirections as n, CheckboxGroupSymbol as C } from "./novoui-vuejs60.js";
const z = /* @__PURE__ */ m({
  inheritAttrs: !1,
  __name: "NCheckboxGroup",
  props: {
    size: {
      type: String,
      required: !1,
      default: B.medium
    },
    direction: {
      type: String,
      required: !1,
      default: n.column
    },
    gap: Boolean,
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    indeterminate: {
      type: Boolean,
      default: !1
    }
  },
  setup(s) {
    const e = s, t = f(), a = o(() => e.size), c = o(() => e.error), i = o(() => t.name), l = o(() => e.disabled), p = o(() => e.indeterminate), d = b({
      size: a,
      name: i,
      disabled: l,
      error: c,
      indeterminate: p
    });
    return g(C, d), (u, S) => (h(), k("div", x({
      class: [
        "checkbox-group",
        {
          "checkbox-group-vertical": e.direction === r(n).column,
          "checkbox-group-gap": e.gap
        }
      ]
    }, r(t)), [
      y(u.$slots, "default")
    ], 16));
  }
});
export {
  z as default
};
